<script lang="ts">
  import Gallery from '$components/product-card/gallery.svelte';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { cn } from '$lib/utils';
  import type { Action } from 'svelte/action';

  import type { CarouselMarketingCardStoryblok } from '$types/bloks';
  import ResponsiveImage from './marketing-sub-blocks/responsive-image.svelte';
  import { getAnchorFromCmsLink } from '$lib/utils/cms';
  import ResponsiveVideo from './responsive-video.svelte';
  import { analyticsEvent, AnalyticsEvents } from '$lib/analytics';

  export let block: CarouselMarketingCardStoryblok;
  export let size: number | undefined = undefined;
  let active = true;

  $: link = block.link?.id ? $getAnchorFromCmsLink(block.link) : null;

  let next: () => void;
  let prev: () => void;
  const galleryKeyboardNav: Action = (node: HTMLElement) => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'ArrowLeft' && prev) prev();
      if (e.key === 'ArrowRight' && next) next();
    };
    node.addEventListener('keydown', handler);
    return {
      destroy: () => node.removeEventListener('keydown', handler)
    };
  };
</script>

<div use:storyblokEditable={block} use:galleryKeyboardNav class="h-full">
  <Gallery
    let:itemClass
    bind:next
    bind:prev
    {active}
    href={link?.href}
    total={(block.assets || []).length}
    class={cn('grow isolation-auto z-10 h-full')}
    on:onSwipe={(e) => {
      const currentIndex = e.detail;
      analyticsEvent({
        event: AnalyticsEvents.SWIPE_MARKETING_CARDS,
        card_type: 'carousel-marketing-card',
        marketing_card_id: block?.marketing_card_id_for_events,
        carousel_index: currentIndex
      });
    }}
  >
    {#each block.assets || [] as asset}
      {#if asset.component == 'responsive-image'}
        <div class="min-w-full h-full overflow-hidden">
          <ResponsiveImage
            image={asset}
            imgClass={cn(itemClass)}
            sizes={{ default: '300px' }}
            widths={[200 * (size || 1), 250 * (size || 1), 300 * (size || 1), 350 * (size || 1)]}
          />
        </div>
      {:else}
        <div class="min-w-full h-full overflow-hidden">
          <ResponsiveVideo block={asset} videoClass={cn(itemClass)} />
        </div>
      {/if}
    {/each}
  </Gallery>
</div>
